import { WarehouseProductRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class WarehouseProductService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new WarehouseProductRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default WarehouseProductService;



// WEBPACK FOOTER //
// ./src/common/data/services/WarehouseProductService.js